import { combineReducers } from "redux"
import { reducer as formReducer } from "redux-form"
import { matchPath } from "react-router"
import { routerReducer } from "react-router-redux"
// TODO vv centralize selectors like so:
import user, * as fromUser from "./user/reducer"
import ui from "./ui/reducer"
import modal from "./modal/reducer"
import enterprise from "./enterprise/reducer"
import accountants from "./accountants/reducer"
import account from "./account/reducer"
import trips from "./trips/reducer"
import transactions from "./transactions/reducer"
import selectLocation from "./trips/selectLocationReducer"
import models from "./models"
import map from "./map/reducer"
import subs from "./subscriptions/reducer"

const WorkStatus = (state, action) => {
  // <-----  name of form given to reduxForm()
  switch (action.type) {
    case "UPDATE_PERSONA_REQUEST":
      return {
        ...state,
        submitting: true,
        values: {
          ...state.values,
          submitting: true
        },
        registeredFields: {
          ...state.registeredFields,
          submitting: true
        }
      }
    case "UPDATE_PERSONA_SUCCESS":
      return {
        ...state,
        submitting: false,
        values: {
          ...state.values,
          submitting: false
        },
        registeredFields: {
          ...state.registeredFields,
          submitting: false
        }
      }
    default:
      return state
  }
}

const BusinessLines = (state, action) => {
  switch (action.type) {
    case "UPDATE_BUSINESS_LINES_REQUEST":
      return {
        ...state,
        submitting: true,
        values: {
          ...state.values,
          submitting: true
        }
      }
    case "UPDATE_BUSINESS_LINES_SUCCESS":
      return {
        ...state,
        submitting: false,
        values: {
          ...state.values,
          submitting: false
        }
      }
    default:
      return state
  }
}

function dev(state = { logLevel: null }, action) {
  switch (action.type) {
    case "SHOW_RF_ACTIONS":
      return {
        ...state,
        logLevel: "VERBOSE"
      }
    default:
      return state
  }
}

/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
export const LOCATION_CHANGE = "@@router/LOCATION_CHANGE"

/**
 * This reducer will update the state with the most recent location history
 * has transitioned to. This may not be in sync with the router, particularly
 * if you have asynchronously-loaded routes, so reading from and relying on
 * this state is discouraged.
 */

const queryString = require("query-string")

export function routerReducerAdvanced(
  state = {
    location: null,
    prev: []
  },
  action
) {
  if (action.type === "@@router/LOCATION_CHANGE") {
    return {
      ...state,
      location: action.payload
    }
  }
  if (action.type === "@@router/LOCATION_SET") {
    return {
      ...state,
      prev: [...state.prev, action.payload],
      location: {
        ...state.location,
        ...action.payload
      }
    }
  }
  if (action.type === "@@router/LOCATION_REMOVE_PARAM") {
    if (!state.location) return state
    const parsed = queryString.parse(state.location.search)
    delete parsed[action.payload]
    return {
      ...state,
      prev: [...state.prev, action.payload],
      location: {
        ...state.location,
        search: Object.keys(parsed).length
          ? "?" + queryString.stringify(parsed)
          : ""
      }
    }
  }

  return state
}

const rootReducer = combineReducers({
  subs,
  models,
  account,
  user,
  ui,
  modal,
  enterprise,
  accountants,
  trips,
  transactions,
  router: routerReducerAdvanced,
  // form: formReducer,
  form: formReducer.plugin({
    WorkStatus,
    BusinessLines
  }),
  // selectLocation,
  map,
  dev
})

// https://github.com/ReactTraining/react-router/blob/master/packages/react-router-redux/modules/selectors.js
export const getLocation = state => state.router.location

export const createMatchSelector = path => {
  let lastPathname = null
  let lastMatch = null
  return state => {
    const { pathname } = getLocation(state) || {}
    if (pathname === lastPathname) {
      return lastMatch
    }
    lastPathname = pathname
    const match = matchPath(pathname, path)
    if (!match || !lastMatch || match.url !== lastMatch.url) {
      lastMatch = match
    }
    return lastMatch
  }
}

export const getFavePlaces = state =>
  Object.values(state.models.places.byId) || []

export const getFavePlacesSorted = state => {
  const { sortBy } = state.models.places

  if (sortBy == "name")
    return getFavePlaces(state).sort(function(a, b) {
      var nameA = a.name.toUpperCase() // ignore upper and lowercase
      var nameB = b.name.toUpperCase() // ignore upper and lowercase
      if (nameA < nameB) {
        return -1
      }
      if (nameA > nameB) {
        return 1
      }

      // names must be equal
      return 0
    })

  // if (sortBy=='date')
  //   return getFavePlaces(state).sort(function (a, b) {
  //     return a.value - b.value;
  //   });

  return getFavePlaces(state)
}

// import auth, * as fromAuth from './auth'
// export const selectUserName = (state) => fromAuth.selectUserName(select.auth);
// // then we can easily import any selectors from this file

// // located here since it's part of BOTH rooms and users
// export const selectUserRoom = (state) => {
//   const userReservation = state.auth.user.reservation;
//   const roomList = state.rooms.list;
//   return roomList.find(room=>room.id===userReservation.roomType)
// }

export default rootReducer



// WEBPACK FOOTER //
// ./src/rootReducer.js